import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { CheckCircle, Package, Home, ShoppingBag } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../core/cart/CartContext';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function PaymentSuccess({ className = '' }: { className?: string }) {
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { clearCart } = useCart();
  
  useEffect(() => {
    const id = searchParams.get('order_id'); 
    setOrderId(id); 
    setLoading(false);
    
    // ✅ Clear cart when user returns from successful PayFast payment
    // This is necessary because form.submit() navigates away before clearCart() 
    // can execute in Checkout.tsx
    clearCart();
  }, [searchParams, clearCart]);
  if (loading) {
    return (<div className={`min-h-screen bg-primary text-tertiary flex items-center justify-center ${className}`}><Header /><div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-tertiary mx-auto"></div><p className="mt-4 text-tertiary/90">Processing payment...</p></div></div>);
  }
  return (
    <div className={`min-h-screen ${className}`} style={{background: 'var(--raisin-black-2)', color: 'var(--white)'}}>
      <Header />
      <div className="h-20" />
      <Helmet><title>Payment Successful - Oracle Gaming</title><meta name="description" content="Your payment was successful" /></Helmet>
      <section className="gears" style={{paddingTop: '120px', paddingBottom: '100px'}}>
        <div className="container">
          <h2 className="h2 section-title" style={{color:'var(--white)', marginBottom: '40px', textAlign: 'center'}}>PAYMENT SUCCESSFUL</h2>
          <div style={{background: 'var(--raisin-black-1)', padding: '60px 40px', textAlign: 'center', borderRadius: '4px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'}}>
            <div style={{background: 'var(--orange)', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 30px'}}>
              <CheckCircle style={{width: '40px', height: '40px', color: 'var(--raisin-black-1)'}} />
            </div>
            <h1 style={{fontSize: '36px', fontWeight: 'bold', color: 'var(--white)', marginBottom: '20px', fontFamily: 'var(--ff-oswald)', textTransform: 'uppercase'}}>Payment Successful!</h1>
            <p style={{fontSize: '18px', color: 'var(--light-gray)', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px', lineHeight: '1.6'}}>🎉 Thank you! Your payment has been processed successfully and your order is being prepared.</p>
            {orderId && (
              <div style={{background: 'var(--raisin-black-2)', borderRadius: '4px', padding: '30px', marginBottom: '40px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', border: '1px solid var(--orange)'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '15px'}}>
                  <Package style={{width: '24px', height: '24px', color: 'var(--orange)'}} />
                  <h3 style={{fontSize: '20px', fontWeight: '600', color: 'var(--white)', fontFamily: 'var(--ff-oswald)', textTransform: 'uppercase'}}>Order Details</h3>
                </div>
                <p style={{fontSize: '16px', color: 'var(--white)', marginBottom: '10px'}}><strong>Order ID:</strong> #{orderId}</p>
                <p style={{color: 'var(--light-gray)'}}>📧 You will receive an email confirmation shortly with tracking information.</p>
              </div>
            )}
            <div style={{display: 'flex', flexDirection: 'row', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
              <Link to="/" className="btn btn-primary" style={{display: 'inline-flex'}}>
                <Home style={{width: '20px', height: '20px'}} />
                Back to Home
              </Link>
              <Link to="/shop" className="btn" style={{border: '1px solid rgba(20, 254, 251, 0.4)', color: 'var(--white)'}}>
                <ShoppingBag style={{width: '20px', height: '20px'}} />
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

